// extracted by mini-css-extract-plugin
export default {"highlight":"fbHj1OCNcm"};